export default __webpack_public_path__ + "static/media/play1.50c1be86.png";